module.exports = __webpack_public_path__ + "static/media/medal-star-yellow.0ebdbc6c.svg";